const parseMessage = (error: unknown) => {
  if (error instanceof Error) {
    const message = error.message || ''
    const name = error.name || 'Error'
    const stack = error.stack ? `\nStack: ${error.stack}` : ''

    // You can format this however you want
    return message || name || stack
  }

  // Fallback for non-Error instances
  return String(error)
}

const parseCode = (error: unknown): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((error as any)?.code) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error as any).code
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((error as any)?.name) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error as any).name
  }

  return ''
}

const parse = (error: unknown) => ({
  message: parseMessage(error),
  code: parseCode(error)
})

const parseUpstream = (error: unknown) => ({
  upstream_message: parseMessage(error),
  upstream_code: parseCode(error)
})

const errorParser = {
  parse,
  parseUpstream,
  parseMessage,
  parseCode
}

export default errorParser
